var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.532 14C11.5696 14 14.872 8.6132 14.872 3.94228C14.872 3.78894 14.872 3.63646 14.8624 3.48484C15.5048 2.98518 16.0592 2.36492 16.5 1.65506C15.9016 1.94107 15.2656 2.12887 14.6152 2.21158C15.3 1.76964 15.8128 1.07529 16.0584 0.256027C15.4136 0.667812 14.7088 0.958129 13.9736 1.11406C12.7304 -0.309101 10.6512 -0.378019 9.3288 0.960714C8.4768 1.82391 8.1144 3.11096 8.3792 4.33856C5.74 4.19555 3.2808 2.85337 1.6136 0.645414C0.7424 2.26068 1.188 4.3265 2.6304 5.36371C2.108 5.34734 1.5968 5.19572 1.14 4.92178V4.96657C1.1408 6.64903 2.2424 8.09803 3.7736 8.43143C3.2904 8.57357 2.7832 8.59424 2.292 8.49173C2.7216 9.93212 3.9544 10.9185 5.3584 10.9469C4.196 11.9307 2.76 12.4649 1.2816 12.4631C1.0208 12.4623 0.76 12.4459 0.5 12.4123C2.0016 13.4495 3.748 14 5.532 13.9974",
    fill: "#616161"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.328e36b235adf9c76a4dd9cd8e6a8f7f.svg";
export { ForwardRef as ReactComponent };